import moment from 'moment'
const now = moment()
const thisYear = now.format('YYYY')
export const thisYearNumber = Number(thisYear)

export function lastFiveYears () {
  let years = []
  for (let i = 0; i < 5; i++) {
    years[i] = thisYearNumber - i
  }
  return years
}
// * 給 navigation 用，沒有的年份填入空白
export function lastFiveYearsStartFrom2019 () {
  let years = []
  for (let i = 0; i < 5; i++) {
    years[i] = thisYearNumber - 2019 - i >= 0 ? thisYearNumber - i : ''
  }
  return years
}

export function lastFiveYearsStartFrom2020 () {
  let years = []
  for (let i = 0; i < 6; i++) {
    years[i] = (thisYearNumber + 1) - 2020 - i >= 0 ? (thisYearNumber + 1) - i : ''
  }
  return years
}

export function YearsStartFrom2019AndLimitFive () {
  let years = []
  for (let i = 0; i < 5; i++) {
    if (thisYearNumber - 2019 - i >= 0) {
      years[i] = thisYearNumber - i
    }
  }
  return years
}
const weekDayConfig = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday'
]

const weekDayShortConfig = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']

const monthConfig = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
]

const monthShortConfig = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

export const daysInMonth = (year, month) => {
  return 32 - new Date(year, month, 32).getDate()
}

export const getWeekday = (date = '', isStringResult) => {
  if (!date) return isStringResult ? '' : -1

  if (typeof date === 'number' || typeof date === 'string') {
    const weekday = new Date(date).getDay()
    return isStringResult ? weekDayConfig[weekday] : weekday
  }

  return isStringResult ? '' : -1
}

export const isSameDay = (d1, d2) => {
  return (
    d1.getFullYear() === d2.getFullYear() &&
    d1.getMonth() === d2.getMonth() &&
    d1.getDate() === d2.getDate()
  )
}

const yymmdd = date => {
  var d = new Date(date)
  var month = '' + (d.getMonth() + 1)
  var day = '' + d.getDate()
  var year = d.getFullYear()

  if (month.length < 2) month = '0' + month
  if (day.length < 2) day = '0' + day

  return `${year}-${month}-${day}`
}

export const format = (date, formatString) => {
  if (formatString === 'yy-mm-dd') return yymmdd(date)

  console.warn('given date format is not found')
  return yymmdd(date)
}

export const getDayAfter = (fromDay, n) => {
  const _fromDay = !fromDay ? new Date() : fromDay
  const otherDay = new Date(_fromDay)
  otherDay.setDate(_fromDay.getDate() + n)
  return otherDay
}

export default {
  daysInMonth,
  getWeekday,
  weekDayShortConfig,
  monthConfig,
  monthShortConfig,
  isSameDay,
  format,
  getDayAfter
}
